import { ChangeDetectorRef, Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { Acesso } from 'src/app/core/acesso';
import { Acoes } from 'src/app/core/acoes';
import { DataUtilService } from 'src/app/services/commons/data-util.service';
import { Funcionario } from '../../../core/funcionario';
import { GrupoAcoes } from '../../../core/grupo-acoes';
import { FuncionarioService } from '../../../services/funcionario/funcionario.service';

@Component({
  selector: 'formulario-acao',
  templateUrl: './formulario-acao.component.html',
  styleUrls: ['./formulario-acao.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }]
})
export class FormularioAcaoComponent implements OnInit {
  
  @Input() grupoAcao: GrupoAcoes;
  @Input() index: number;
  @Input() acoes: Acoes[];
  @Input() acao: Acoes;
  @Input() perfilAcesso: Acesso;
  @Input() perfilAcessoAnalise: Acesso;
  @Input() camposDesabilitados: boolean;
  funcionarioResponsavelAnalise: Funcionario | null = null;

  pinDataPrevisaoInicio    = Date.now();
  pinLocalExecucao         = Date.now();
  pinDescricao             = Date.now();
  
  local_execucao: any[] = [
    {tipo: 'Interna', flag: 'I'},
    {tipo: 'Externa', flag: 'E'}
  ];

  statusAnaliseCombo: any[] = [
    { id: "A", descricao: "Aprovado" },
    { id: "R", descricao: "Reprovado" },
  ];

  pinRandom = Math.random();

  
  constructor(private drc: ChangeDetectorRef,
    private funcionarioService: FuncionarioService,
    private dataUtilService: DataUtilService) { }

  ngOnInit(): void {
    this.funcionarioService.getByPessoaFisica(this.grupoAcao.usuarioAnalise.pessoaFisica.id).subscribe((funcionarioLogado: Funcionario) => {
      this.funcionarioResponsavelAnalise = funcionarioLogado;
    })
  }

  ngAfterContentChecked(): void {
    this.drc.detectChanges();
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  deletarAcao() {
    this.acoes.splice(this.index, 1);
  }

  isShowFormularioAnalise(): Boolean {
    return this.grupoAcao.statusEnvioAnalise && this.perfilAcessoAnalise.consulta;
  }

  onStatusAnaliseChange(value: any): void {
    if (value) {
      this.acao.funcionarioAprovaAcao = this.funcionarioResponsavelAnalise;
    } else {
      this.acao.funcionarioAprovaAcao = null;
    }
  }

}
